import useScrollAnimation from '@/hooks/useScrollAnimation';

export default function ContactSection() {
  const { ref, isVisible } = useScrollAnimation();

  const handleCall = () => {
    window.location.href = 'tel:07077860873';
  };

  return (
    <section id="contact" className="relative py-20 md:py-28 px-4 md:px-6 bg-background-100 overflow-hidden">
      <div className="absolute top-0 right-0 w-64 h-64 bg-primary-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-secondary-100/30 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div
        ref={ref}
        className={`relative z-10 max-w-4xl mx-auto transition-all duration-1000 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="mb-16">
          <p className="text-center text-primary-500 font-sans text-xs tracking-[0.4em] mb-4">
            CONTACT
          </p>
          <h2 className="text-center font-heading text-2xl md:text-3xl text-foreground-800 mb-3 tracking-wider">
            ご予約・お問い合わせ
          </h2>
          <div className="w-12 h-[1px] bg-secondary-400 mx-auto mb-6"></div>
          <p className="text-foreground-600 text-sm leading-relaxed max-w-md mx-auto ms:text-left md:text-center">
            ご予約は公式LINEまたはエステ魂にて承っております。<br />
            お電話での対応も可能ですが、出られない場合がございます。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-2xl mx-auto">
          <a
            href="tel:07077860873"
            onClick={(e) => {
              e.preventDefault();
              handleCall();
            }}
            className="group flex flex-col items-center gap-3 p-8 bg-background-50 rounded-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
          >
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100/70 transition-all duration-300 group-hover:bg-primary-200/80 group-hover:scale-110">
              <i className="ri-phone-line text-2xl text-primary-500"></i>
            </div>
            <span className="font-sans text-sm text-foreground-800 tracking-wider">お電話</span>
            <span className="text-foreground-500 text-xs">070-7786-0873</span>
          </a>

          <a
            href="https://line.me/ti/p/zcTZh94HXd"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-3 p-8 bg-background-50 rounded-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
          >
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100/70 transition-all duration-300 group-hover:bg-accent-200/80 group-hover:scale-110">
              <i className="ri-line-line text-2xl text-accent-500"></i>
            </div>
            <span className="font-sans text-sm text-foreground-800 tracking-wider">LINE公式</span>
            <span className="text-foreground-500 text-xs">友だち追加はこちら</span>
          </a>

          <a
            href="https://www.instagram.com/yunohana0873"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-3 p-8 bg-background-50 rounded-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
          >
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-100/70 transition-all duration-300 group-hover:bg-secondary-200/80 group-hover:scale-110">
              <i className="ri-instagram-line text-2xl text-secondary-500"></i>
            </div>
            <span className="font-sans text-sm text-foreground-800 tracking-wider">Instagram</span>
            <span className="text-foreground-500 text-xs">@yunohana0873</span>
          </a>
        </div>

        <div className="mt-16">
          <p className="text-center text-primary-500 font-sans text-xs tracking-[0.4em] mb-4">
            RESERVATION
          </p>
          <h3 className="text-center font-heading text-xl md:text-2xl text-foreground-800 mb-3 tracking-wider">
            各種予約サイト
          </h3>
          <div className="w-12 h-[1px] bg-secondary-400 mx-auto mb-8"></div>

          <div className="max-w-xs mx-auto">
            <a
              href="https://estama.jp/shop/50473/"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-center gap-3 p-6 bg-background-50 rounded-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100/70 transition-all duration-300 group-hover:bg-primary-200/80 group-hover:scale-110">
                <i className="ri-calendar-check-line text-xl text-primary-500"></i>
              </div>
              <div className="text-left">
                <span className="block font-sans text-sm text-foreground-800 tracking-wider">エステ魂</span>
                <span className="block text-foreground-500 text-xs">ご予約はこちら</span>
              </div>
            </a>
          </div>
        </div>

        <div className="text-center mt-14">
          <button
            onClick={handleCall}
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-sans font-medium px-12 py-4 rounded-full text-sm tracking-wider transition-all duration-300 hover:scale-105 animate-pulse-soft"
          >
            <i className="ri-phone-line text-lg"></i>
            今すぐ電話で予約する
          </button>
        </div>
      </div>
    </section>
  );
}